/**
 * FauxDS Link
 *
 * ⚠️ This is a SIMPLIFIED RECREATION of the Slate Link component for prototyping.
 * It is NOT the real @faire/slate Link and should NOT be used for:
 * - Engineering handoff
 * - Design specs
 * - Production code
 *
 * For the real Slate Link, see: @faire/slate/components/link
 */
import { cn } from "@faire/prototype-playground/lib/utils";
import React from "react";

export interface LinkProps {
  /**
   * The URL the link points to
   */
  href: string;
  /**
   * Link content
   */
  children: React.ReactNode;
  /**
   * Whether to open in a new tab
   * @default false
   */
  external?: boolean;
  /**
   * Optional className for additional styling
   */
  className?: string;
  /**
   * Click handler
   */
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
}

/**
 * Link - FauxDS (recreated from Slate)
 *
 * Component with basic link styling.
 * This is a simplified implementation for prototyping purposes.
 */
export default function Link({
  href,
  children,
  external = false,
  className = "",
  onClick,
}: LinkProps) {
  return (
    <a
      href={href}
      onClick={onClick}
      target={external ? "_blank" : undefined}
      rel={external ? "noopener noreferrer" : undefined}
      className={cn(
        "inline text-inherit underline underline-offset-[0.25em] transition-opacity hover:opacity-80 focus:outline-hidden focus-visible:ring-2 focus-visible:ring-[var(--slate-color-action-border-focus-ring)] focus-visible:ring-offset-2",
        className
      )}
    >
      {children}
    </a>
  );
}
